import firebase from "firebase/compat/app";
import capitalize from "lodash/capitalize";
import fb from "../lib/firebase";
import {getFazendaNomeCompleto} from "./Fazenda";

export type AppCollection = 'fazendas' | 'lojas' | 'veterinarios' | 'eventos' | string;


export interface Principal {
  id: string;
  nome: string;
  label: string;
  type: AppCollection;
  _fullName: string;
}

export function preparePrincipal <T>(document: firebase.firestore.DocumentSnapshot): T {
  const label = getPrincipalLabel(document.ref.parent.id);
  const documentData = fb.doc(document);
  const _fullName = getPrincipalFullName(document, documentData);
  return {
    ...documentData,
    label,
    _fullName,
  };
}

export const getPrincipalLabel = (path: AppCollection): string => {
  switch (path) {
    case "fazendas":
      return "Fazenda";
    case "lojas":
      return "Loja";
    case "veterinarios":
      return "Veterinário";
    default:
      return capitalize(path);
  }
}

export const getPrincipalFullName = (document: firebase.firestore.DocumentSnapshot, documentData: any): string => {
  const path = document.ref.parent.id;
  if (path === 'fazendas')
    return getFazendaNomeCompleto(documentData);

  return documentData.nome;
}
